import { ContentPillar, ContentThematicCategory } from "../models/contents.entity";

export const contentPillarTranslation = {
    [ContentPillar.BODY]: "le corps",
    [ContentPillar.MIND]: "le mental",
    [ContentPillar.RELATIONS]: "les relations",
    [ContentPillar.POSTURE]: "posture et philosophie de vie",
    [ContentPillar.INDIVIDUAL]: "le mental",
    [ContentPillar.ENVIRONMENT]: "les relations",
    [ContentPillar.EVENT]: "le corps",
};

export const contentThematicCategoryTranslation = {
    [ContentThematicCategory.PERSONAL_LIFE]: "vie personnelle",
    [ContentThematicCategory.BETTER_LIFE]: "mieux-être",
    [ContentThematicCategory.PROFESSIONAL_LIFE]: "vie professionnelle",
    [ContentThematicCategory.SELF_REFLECTION]: "travail sur soi",
};